import { theme } from "antd";
import React, { HTMLAttributes } from "react";

export const SearchIcon: React.FC<HTMLAttributes<HTMLOrSVGElement>> = (
  props
) => {
  const { token } = theme.useToken();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      {...props}
    >
      <path
        d="M9.37837 17.1111C13.4533 17.1111 16.7567 13.7284 16.7567 9.55554C16.7567 5.38273 13.4533 2 9.37837 2C5.30341 2 2 5.38273 2 9.55554C2 13.7284 5.30341 17.1111 9.37837 17.1111Z"
        stroke={token.colorPrimary}
        strokeWidth="2.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6018 18.999L14.5898 14.8906"
        stroke={token.colorPrimary}
        strokeWidth="2.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
